import { Outlet } from 'react-router-dom'
import { AppContentLoader, LoaderSwitcher } from 'router/loaders'
import { NavBar } from 'shop/components'

export const PasswordWrapper = () => {
  return (
    <AppContentLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <>
            <NavBar />
            <Outlet />
          </>
        </LoaderSwitcher>
      )}
    </AppContentLoader>
  )
}
